enum FieldDictionaryUsedBy {
    Nothing,
    PDF,
    CSP,
    SupplierPortal,
    BuyerPortal,
}

export default FieldDictionaryUsedBy;
